<template>
  <div class="modal bg-opacity-50 bg-black" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Binded Social Media</h5>
          <span aria-hidden="true" role="button" @click="close"
            ><i class="fas fa-xmark"></i
          ></span>
        </div>
        <div class="modal-body">
          <div
            class="container"
            v-if="Object.keys(this.data.entity.social_media).length > 0"
          >
            <div
              class="row my-4"
              v-for="social of Object.keys(this.data.entity.social_media)"
              :key="social"
            >
              <div class="col-6 text-center">
                <span class="h4"
                  ><i :class="this.socialMediaIcons[social]"></i>
                  {{ this.socialMediaNames[social] }}</span
                >
              </div>
              <div class="col-6 text-center">
                <span class="h4">{{
                  this.data.entity.social_media[social]
                }}</span>
              </div>
            </div>
          </div>
          <div class="text-center" v-else>
            <h4>Identical to the email address associated with the account.</h4>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="close">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowBind",
  data() {
    return {
      socialMediaNames: {
        google: "Google",
        apol: "Apple",
        apple: "Apple",
        facebook: "Facebook",
      },
      socialMediaIcons: {
        google: "fab fa-google",
        apol: "fab fa-apple",
        apple: "fab fa-apple",
        facebook: "fab fa-facebook",
      },
      viewData: {},
    };
  },
  props: {
    data: {
      entity: Object,
      show: Boolean,
    },
  },
  components: {},
  methods: {
    close() {
      let data = this.data;
      data.show = false;
    },
  },
  async mounted() {},
};
</script>

<style scoped></style>
